<template>
  <button
    class="login_button"
    :class="`login_${service}`"
    @click.prevent="onClick"
  >
    <img :src="`/img/${service}_icon.png`" class="login_icon" />
    <p :class="loginClass">{{ loginText }}</p>
  </button>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'

const Services = {
  Apple: 'apple',
  X: 'x',
  Google: 'google',
  Line: 'line',
} as const
type Service = typeof Services[keyof typeof Services]

@Component
export default class LoginButton extends Vue {
  @Prop({
    validator: (v: Service) => {
      return Object.values(Services).includes(v)
    },
  })
  service!: Service

  @Emit('click')
  onClick() {}

  get loginText() {
    return this.$t(`login__button__agree_and_log_in`)
  }

  get loginClass() {
    return 'login_text -' + this.$i18n.locale
  }
}
</script>

<style scoped>
.login_button {
  width: 240px;
  height: 48px;
  padding: 8px 8px;
  border-radius: 24px;
  color: #ffffff;
  cursor: pointer;
  border: none;
}

.login_icon {
  width: 32px;
  height: 32px;
}

.login_text {
  width: calc(192px - 8px);
  display: inline-block;
  font-size: 13px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0.5px;
  text-align: center;
}

/* latin alphabet style */
.login_text.-en,
.login_text.-es,
.login_text.-pt-BR,
.login_text.-id,
.login_text.-fr,
.login_text.-ru,
.login_text.-de,
.login_text.-ms {
  font-size: 10px;
  letter-spacing: inherit;
}

.login_apple {
  background-color: #262626;
}

.login_google {
  color: #606060;
  border: 1px solid #bababa;
  background-color: #ffffff;
}

.login_x {
  background-color: #262626;
}

.login_line {
  background-color: #06c755;
}
</style>
